import type { ApplicationInsights } from '@microsoft/applicationinsights-web';

import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoadingComponent } from '@components/loading/loading.component';
import { APP_INSIGHTS_INSTANCE_TOKEN } from '@services/app-insights.token';

import { ThemeService } from './modules/admin/modules/features/workspace/page-builder/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly APP_INSIGHTS: ApplicationInsights = inject(APP_INSIGHTS_INSTANCE_TOKEN);
  private readonly themeService = inject(ThemeService);

  public ngOnInit(): void {
    this.APP_INSIGHTS?.loadAppInsights();
    this.themeService.init();
  }
}
